
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M7 0c3.85 0 7 3.15 7 7s-3.15 7-7 7-7-3.15-7-7 3.15-7 7-7zm3.814 4.508a.438.438 0 00-.619-.01L6 8.579 3.805 6.442a.437.437 0 10-.61.628l2.5 2.43c.17.165.44.165.61 0l4.5-4.375a.438.438 0 00.009-.618z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M7 0c3.85 0 7 3.15 7 7s-3.15 7-7 7-7-3.15-7-7 3.15-7 7-7zm3.814 4.508a.438.438 0 00-.619-.01L6 8.579 3.805 6.442a.437.437 0 10-.61.628l2.5 2.43c.17.165.44.165.61 0l4.5-4.375a.438.438 0 00.009-.618z"}})])
          )
        }
      }
    